import almaGrey from '../../../../../assets/images/apps/alma.png'
import alma from '../../../../../assets/images/apps/alma.png'
import cassandraGrey from '../../../../../assets/images/apps/cassandra-grey.png'
import cassandra from '../../../../../assets/images/apps/cassandra.png'
import centosGrey from '../../../../../assets/images/apps/centos-grey.png'
import centos from '../../../../../assets/images/apps/centos.png'
import cpanelGrey from '../../../../../assets/images/apps/cpanel-grey.png'
import cpanel from '../../../../../assets/images/apps/cpanel.png'
import debian from '../../../../../assets/images/apps/debian.png'
import erpnext from '../../../../../assets/images/apps/erpnext.png'
import erpnextGrey from '../../../../../assets/images/apps/erpnext-grey.png'
import jenkinsGrey from '../../../../../assets/images/apps/jenkins-grey.png'
import jenkins from '../../../../../assets/images/apps/jenkins.png'
import joomlaGrey from '../../../../../assets/images/apps/joomla-grey.png'
import joomla from '../../../../../assets/images/apps/joomla.png'
import magentoGrey from '../../../../../assets/images/apps/magento-grey.png'
import magento from '../../../../../assets/images/apps/magento.png'
import mariadbGrey from '../../../../../assets/images/apps/mariadb-grey.png'
import mariadb from '../../../../../assets/images/apps/mariadb.png'
import mattermostGrey from '../../../../../assets/images/apps/mattermost-grey.png'
import mattermost from '../../../../../assets/images/apps/mattermost.png'
import meanGrey from '../../../../../assets/images/apps/mean-grey.png'
import mean from '../../../../../assets/images/apps/mean.png'
import mediawikiGrey from '../../../../../assets/images/apps/mediawiki-grey.png'
import mediawiki from '../../../../../assets/images/apps/mediawiki.png'
import memcachedGrey from '../../../../../assets/images/apps/memcached-grey.png'
import memcached from '../../../../../assets/images/apps/memcached.png'
import mongodbGrey from '../../../../../assets/images/apps/mongodb-grey.png'
import mongodb from '../../../../../assets/images/apps/mongodb.png'
import moodleGrey from '../../../../../assets/images/apps/moodle-grey.png'
import moodle from '../../../../../assets/images/apps/moodle.png'
import multicraftGrey from '../../../../../assets/images/apps/multicraft-grey.png'
import multicraft from '../../../../../assets/images/apps/multicraft.png'
import mysqlGrey from '../../../../../assets/images/apps/mysql-grey.png'
import mysql from '../../../../../assets/images/apps/mysql.png'
import nginxGrey from '../../../../../assets/images/apps/nginx-grey.png'
import nginx from '../../../../../assets/images/apps/nginx.png'
import odooGrey from '../../../../../assets/images/apps/odoo-grey.png'
import odoo from '../../../../../assets/images/apps/odoo.png'
import phpbbGrey from '../../../../../assets/images/apps/phpbb-grey.png'
import phpbb from '../../../../../assets/images/apps/phpbb.png'
import pleskGrey from '../../../../../assets/images/apps/plesk-grey.png'
import plesk from '../../../../../assets/images/apps/plesk.png'
import postgresqlGrey from '../../../../../assets/images/apps/postgresql-grey.png'
import postgresql from '../../../../../assets/images/apps/postgresql.png'
import prestashopGrey from '../../../../../assets/images/apps/prestashop-grey.png'
import prestashop from '../../../../../assets/images/apps/prestashop.png'
import redhatGrey from '../../../../../assets/images/apps/redhat-grey.png'
import redhat from '../../../../../assets/images/apps/redhat.png'
import redisGrey from '../../../../../assets/images/apps/redis-grey.png'
import redis from '../../../../../assets/images/apps/redis.png'
import rockyGrey from '../../../../../assets/images/apps/rocky-grey.png'
import rocky from '../../../../../assets/images/apps/rocky.png'
import sqlserverGrey from '../../../../../assets/images/apps/sqlserver-grey.png'
import sqlserver from '../../../../../assets/images/apps/sqlserver.png'
import sugarGrey from '../../../../../assets/images/apps/sugar-grey.png'
import sugar from '../../../../../assets/images/apps/sugar.png'
import tomcatGrey from '../../../../../assets/images/apps/tomcat-grey.png'
import tomcat from '../../../../../assets/images/apps/tomcat.png'
import ubuntuGrey from '../../../../../assets/images/apps/ubuntu-grey.png'
import ubuntu from '../../../../../assets/images/apps/ubuntu.png'
import windowsGrey from '../../../../../assets/images/apps/windows-grey.png'
import windows from '../../../../../assets/images/apps/windows.png'
import wordpressGrey from '../../../../../assets/images/apps/wordpress-grey.png'
import wordpress from '../../../../../assets/images/apps/wordpress.png'
import { ShortName } from '../../../Cloud.model';

export interface IconImageConfig {
    shortName: ShortName,
    png: any,
    pngGrey: any
}

export const iconImageConfig: IconImageConfig[] = [
    {
        shortName: ShortName.alma,
        png: alma,
        pngGrey: almaGrey
    },
    {
        shortName: ShortName.cassandra,
        png: cassandra,
        pngGrey: cassandraGrey
    },
    {
        shortName: ShortName.centos,
        png: centos,
        pngGrey: centosGrey
    },
    {
        shortName: ShortName.cpanel,
        png: cpanel,
        pngGrey: cpanelGrey
    },
    {
        shortName: ShortName.debian,
        png: debian,
        pngGrey: debian
    },
    {
        shortName: ShortName.erpnext,
        png: erpnext,
        pngGrey: erpnextGrey
    },
    {
        shortName: ShortName.jenkins,
        png: jenkins,
        pngGrey: jenkinsGrey
    },
    {
        shortName: ShortName.joomla,
        png: joomla,
        pngGrey: joomlaGrey
    },
    {
        shortName: ShortName.magento,
        png: magento,
        pngGrey: magentoGrey
    },
    {
        shortName: ShortName.mariadb,
        png: mariadb,
        pngGrey: mariadbGrey
    },
    {
        shortName: ShortName.mattermost,
        png: mattermost,
        pngGrey: mattermostGrey
    },
    {
        shortName: ShortName.mean,
        png: mean,
        pngGrey: meanGrey
    },
    {
        shortName: ShortName.mediawiki,
        png: mediawiki,
        pngGrey: mediawikiGrey
    },
    {
        shortName: ShortName.memcached,
        png: memcached,
        pngGrey: memcachedGrey
    },
    {
        shortName: ShortName.mongodb,
        png: mongodb,
        pngGrey: mongodbGrey
    },
    {
        shortName: ShortName.moodle,
        png: moodle,
        pngGrey: moodleGrey
    },
    {
        shortName: ShortName.multicraft,
        png: multicraft,
        pngGrey: multicraftGrey
    },
    {
        shortName: ShortName.mysql,
        png: mysql,
        pngGrey: mysqlGrey
    },
    {
        shortName: ShortName.nginx,
        png: nginx,
        pngGrey: nginxGrey
    },
    {
        shortName: ShortName.odoo,
        png: odoo,
        pngGrey: odooGrey
    },
    {
        shortName: ShortName.phpbb,
        png: phpbb,
        pngGrey: phpbbGrey
    },
    {
        shortName: ShortName.plesk,
        png: plesk,
        pngGrey: pleskGrey
    },
    {
        shortName: ShortName.postgresql,
        png: postgresql,
        pngGrey: postgresqlGrey
    },
    {
        shortName: ShortName.prestashop,
        png: prestashop,
        pngGrey: prestashopGrey
    },
    {
        shortName: ShortName.redhat,
        png: redhat,
        pngGrey: redhatGrey
    },
    {
        shortName: ShortName.redis,
        png: redis,
        pngGrey: redisGrey
    },
    {
        shortName: ShortName.rocky,
        png: rocky,
        pngGrey: rockyGrey
    },
    {
        shortName: ShortName.sqlserver,
        png: sqlserver,
        pngGrey: sqlserverGrey
    },
    {
        shortName: ShortName.sugar,
        png: sugar,
        pngGrey: sugarGrey
    },
    {
        shortName: ShortName.tomcat,
        png: tomcat,
        pngGrey: tomcatGrey
    },
    {
        shortName: ShortName.ubuntu,
        png: ubuntu,
        pngGrey: ubuntuGrey
    },
    {
        shortName: ShortName.bitnami,
        png: ubuntu,
        pngGrey: ubuntuGrey
    },
    {
        shortName: ShortName.windows,
        png: windows,
        pngGrey: windowsGrey
    },
    {
        shortName: ShortName.wordpress,
        png: wordpress,
        pngGrey: wordpressGrey
    }
]
